import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../shared/sidebar/SubHeader";
import SidebarComponent from "../../shared/sidebar/SidebarComponent";
import Links from "../../utilities/linksConfig/Links";
import DashboardTabContainer from "./dashboard/DashboardTabContainer";
import DanekontaTabContainer from "./danekonta/DanekontaTabContainer";
import LogowanieService from "../logowanie/LogowanieService";
import KluczMobilnyTabContainer from "./kluczmobilny/KluczMobilnyTabContainer";
import KonfiguracjaService from "../administracja/konfiguracja/KonfiguracjaService";

export default class HomeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: (LogowanieService.sprawdzCzyToUrzad() || Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(['ROLE_LPP'])))?2:1,
            user: LogowanieService.pobierzZalogowanego(),
            QR_URL:'',
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)

    }

    componentDidMount(){
        this.pobierzURLDoKoduQR()
    }

    pobierzURLDoKoduQR(){
        KonfiguracjaService.pobierzPojedynczyObiektZConfigu('TOP','UrlKodAztec').then(function (response) {
            if(response.status<300){
                this.setState({QR_URL: response.data.wartosc})
            }
        }.bind(this))
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            return <DashboardTabContainer/>
        }
        else if (this.state.activeTab === 2){
            return <DanekontaTabContainer user={this.state.user}/>
        }
        else{
            return <KluczMobilnyTabContainer user={this.state.user} QR_URL={this.state.QR_URL}/>
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                collapsedLinks={this.props.collapsedLinks} handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}
            >
                <Grid fluid={true} id={'HomeContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history} collapsedLinks={this.props.collapsedLinks}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={(LogowanieService.sprawdzCzyToUrzad() || Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(['ROLE_LPP'])))?2:1} id="home-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Dashboard" disabled={LogowanieService.sprawdzCzyToUrzad() || Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(['ROLE_LPP']))}>
                                </Tab>
                                <Tab eventKey={2} title="Dane konta">
                                </Tab>
                                <Tab eventKey={3} title="Zarządzanie kluczem mobilnym"  disabled={LogowanieService.sprawdzCzyToUrzad()}>
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/home/HomeContainer.js